module.exports = __webpack_public_path__ + "static/media/tabletochki.c46e759a.svg";